import { ConfirmDialog } from "@/pages/tina/festivals/components/confirm-dialog";
import {
  DIRTY_DROPPED,
  unpublishText,
} from "@/pages/tina/festivals/lib/page-copy";
import type { FestivalPageRead } from "@/types/tina-festival-page";

interface UnpublishDialogProps {
  page: FestivalPageRead;
  dirty: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/** Unpublish says which day events Tina deletes and which stay in Mood, before it does either. */
export function UnpublishDialog({
  page,
  dirty,
  open,
  onOpenChange,
  onConfirm,
}: UnpublishDialogProps) {
  const text = unpublishText(page);
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={text.title}
      description={
        dirty ? `${text.description} ${DIRTY_DROPPED}` : text.description
      }
      confirmLabel="Unpublish"
      cancelLabel="Keep it published"
      onConfirm={onConfirm}
    >
      {text.deleted.length > 0 ? (
        <div className="text-sm">
          <p className="font-medium">
            Deleted, unless someone saved them since:
          </p>
          <ul className="list-disc pl-5">
            {text.deleted.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {text.staying.length > 0 ? (
        <div className="text-sm">
          <p className="font-medium">Stay in Mood as normal events:</p>
          <ul className="list-disc pl-5">
            {text.staying.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </ConfirmDialog>
  );
}
